import { useEffect, useRef, useState } from 'react'

import { SwiperSlide } from 'swiper/react'

import useSeatmapStore, {
  SEAT_VIEW_PLACEHOLDER,
} from '../../../../stores/seatmapStore'
import useFiltersStore from '../../../../stores/filtersStore'

import Button from 'react-bootstrap/Button'

import { Slider } from '../../../Slider'

import chevronleft from '../../../../assets/icons/chevronleft.svg'

import './viewSwiper.scss'

export default function ViewSwiper({
  viewingSectionId,
  smallButtons = false,
  imageHeight = 230,
  sectionNumber,
  slug,
}) {
  // Zustand
  const getTicketImage = useSeatmapStore((state) => state.getTicketImage)
  const event = useFiltersStore((state) => state.event)

  const navigationPrevRef = useRef(null)
  const navigationNextRef = useRef(null)

  const sliderKey = `slider-${viewingSectionId}-${Math.random()}`

  const [availableImages, setAvailableImages] = useState([])

  const venueSlug = event?.venue?.slug ? event?.venue?.slug : slug

  useEffect(() => {
    const checkImages = async () => {
      const imageTypes = ['highlights', 'seat-view']
      const available = []

      for (const type of imageTypes) {
        const imgUrl = getTicketImage(
          venueSlug,
          sectionNumber?.toLowerCase(),
          type
        )

        available.push({
          type,
          url: imgUrl,
          key: type === 'highlights' ? 1 : 2,
          alt:
            type === 'highlights'
              ? 'Seat position for this section'
              : 'Seat view for this ticket',
        })
      }
      setAvailableImages(available)
    }

    checkImages()

    return () => {
      setAvailableImages([])
    }
  }, [viewingSectionId, event, getTicketImage])

  return (
    <div className="--tslider">
      <div className={`button-box ${smallButtons && '--smallbuttons'}`}>
        <Button
          variant="outline-light"
          className="btn--icon --left"
          ref={navigationPrevRef}
          aria-label="left arrow"
        >
          <img src={chevronleft} alt="left arrow" />
        </Button>
        <Button
          variant="outline-light"
          className="btn--icon --right"
          ref={navigationNextRef}
          aria-label="right arrow"
        >
          <img src={chevronleft} alt="left arrow" />
        </Button>
      </div>
      <div className="vjx-swiper-img-wrap" style={{ height: imageHeight }}>
        <Slider
          key={sliderKey}
          slidesPerView={1}
          navigationPrevRef={navigationPrevRef}
          navigationNextRef={navigationNextRef}
        >
          {availableImages.map((image) => (
            <SwiperSlide key={image.key} className="swiper-lazy">
              <SmoothLoadingImage
                src={image.url}
                alt={image.alt}
                fallbackSrc={
                  image.type === 'seat-view' ? SEAT_VIEW_PLACEHOLDER : undefined
                }
              />
            </SwiperSlide>
          ))}
        </Slider>
      </div>
    </div>
  )
}

const SmoothLoadingImage = ({ src, alt, fallbackSrc }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [resolvedSrc, setResolvedSrc] = useState(src)

  useEffect(() => {
    setResolvedSrc(src)
    setHasError(false)
    setIsLoaded(false)
  }, [src])

  if (hasError) {
    return (
      <div role="img" aria-label="image not available">
        Image not available
      </div>
    )
  }

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={`smooth-image ${isLoaded ? 'loaded' : ''}`}
      onLoad={() => setIsLoaded(true)}
      onError={() => {
        if (fallbackSrc && resolvedSrc !== fallbackSrc) {
          setResolvedSrc(fallbackSrc)
          setIsLoaded(false)
          return
        }

        console.warn(`Failed to load image: ${src} for alt: ${alt}`)
        setHasError(true)
      }}
    />
  )
}
